<template>
  <div>
    <div class="wc-validated-input">
      <WCInput
        :state="vuelidateObject.$error ? 'invalid' : null"
        @input="vuelidateObject.$touch()"
        v-model="_model"
        v-on="listeners"
        v-bind="$attrs"
      />

      <!--Warning Icon-->
      <button
        type="button"
        :aria-label="$t('invalidField')"
        ref="wc-validated-input__warning-icon-overlay"
        class="unstyled-btn wc-validated-input__warning-icon-overlay"
      ></button>
      <WCToolTip
        v-if="$scopedSlots.default"
        target="wc-validated-input__warning-icon-overlay"
        position="right"
        :delay-millis="500"
      >
        <slot />
      </WCToolTip>
    </div>
  </div>
</template>

<script>
import WCInput from '@/modules/forms/components/WCInput/WCInput.vue';
import WCToolTip from '@/components/WCToolTip/WCToolTip.vue';

export default {
  name: 'WCValidatedInput',
  components: { WCToolTip, WCInput },
  inheritAttrs: false,
  props: {
    value: {},
    vuelidateObject: {
      type: Object,
      required: true,
    },
  },
  computed: {
    listeners() {
      const { input, ...listeners } = this.$listeners;
      return listeners;
    },
    _model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/assets/styles/_tools.scss';
@import '~@/assets/styles/_settings.scss';

.wc-validated-input {
  position: relative;
  .wc-validated-input__warning-icon-overlay {
    display: none;
  }

  // Target the (i) warning icon when it is present
  ::v-deep .form-control.is-invalid {
    // Position a pseudo element over the (i) icon to anchor a tooltip
    + .wc-validated-input__warning-icon-overlay {
      display: block;
      height: 1rem;
      width: 1rem;
      position: absolute;
      top: calc(50% - 0.5rem);
      right: 0.7rem;
    }
  }
}
</style>
